import React from "react";

function WhiteCross() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M3.75736 3.75736C2.67157 4.84315 2 6.34315 2 8C2 11.3137 4.68629 14 8 14C9.65685 14 11.1569 13.3284 12.2426 12.2426M3.75736 3.75736C4.84315 2.67157 6.34315 2 8 2C11.3137 2 14 4.68629 14 8C14 9.65685 13.3284 11.1569 12.2426 12.2426M3.75736 3.75736L8 8L12.2426 12.2426"
        stroke="#D4D4D8"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default WhiteCross;
